<template>
    <div v-if="!isUserStats">
        <div class="common-header">
            <div class="common-header-left">
                用户ID：
                <el-input
                        type="textarea"
                        resize="none"
                        placeholder="输入用户ID，多个用 ' , ' 分隔"
                        v-model.trim="searchVal">
                </el-input>
            </div>
            <div class="common-header-right">
                <div class="common-header-block">
                    时间：
                    <el-date-picker
                            v-model="date"
                            format="yyyy-MM-dd HH:mm"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    系数比例：
                    <el-select style="width: 100px" v-model="coefficient">
                        <el-option
                                v-for="item of coefficientOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"/>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                    <el-button v-if="permissions.osm_room_info_export" type="success" @click="exportFunc">导出
                    </el-button>
                </div>
            </div>
        </div>

        <strong class="common-text-item" v-text="`成功查询出玩家：${batchUserStats.total}个`"></strong>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="batchUserStats.beanList"
                    @row-click="rowClick"
                    :row-key="row=>JSON.stringify(row)"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="用户ID" width="120" align="center" prop="userRandomId"/>
                <el-table-column label="用户昵称" width="150" align="center" prop="userNickname"/>
                <el-table-column label="金豆余额(可提/不可提/总金豆)" width="250" align="center">
                    <template slot-scope="scope">{{scope.row.extractableChip|numberChip}}/
                      {{scope.row.notExtractableChip|numberChip}}/{{scope.row.totalChip|numberChip}}</template>
                </el-table-column>
                <el-table-column label="JP击中" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.totalJpPl}} 记分牌</template>
                </el-table-column>
                <el-table-column label="JP贡献" align="center" prop="totalJp">
                  <template slot-scope="scope">{{scope.row.totalJp|numberChip}}</template>
                </el-table-column>
                <el-table-column label="积分" align="center" prop="totalIntegral">
                  <template slot-scope="scope">{{scope.row.totalIntegral|numberChip}}</template>
                </el-table-column>
                <el-table-column label="系数积分" align="center" prop="totalCoefficientIntegral">
                  <template slot-scope="scope">{{scope.row.totalCoefficientIntegral|numberChip}}</template>
                </el-table-column>
                <el-table-column label="总带入" align="center" prop="totalBring">
                  <template slot-scope="scope">{{scope.row.totalBring|numberChip}}</template>
                </el-table-column>
                <el-table-column label="保险" align="center" prop="totalInsurancePool">
                  <template slot-scope="scope">{{scope.row.totalInsurancePool|numberChip}}</template>
                </el-table-column>
                <el-table-column label="俱乐部" width="180" align="center" prop="clubName"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="batchUserStats.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>

    <comp-user-stats v-else :user-id="userId" :date="date" :coefficient="coefficient" @my-close="isUserStats = false"/>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import compUserStats from './compUserStats'

    export default {
        components: {
            compUserStats
        },
        data() {
            return {
                isUserStats: false,
                loading: false,
                date: null,
                searchVal: '',
                coefficient: '', // 百分比
                coefficientOptions: [
                    {label: '全部', value: ''},
                    {label: '1%', value: '1'},
                    {label: '2%', value: '2'},
                    {label: '3%', value: '3'},
                    {label: '4%', value: '4'},
                    {label: '5%', value: '5'},
                    {label: '6%', value: '6'},
                    {label: '7%', value: '7'},
                    {label: '8%', value: '8'},
                    {label: '9%', value: '9'},
                    {label: '10%', value: '10'},
                ],
                currentPage: 1,
                batchUserStats: {// 战绩批量查询
                    beanList: [],
                    total: 0
                },
            }
        },
        computed: {
            ...mapState('login', ['permissions']),
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('gameDetail', ['getBatchUserStats']),
            parameterCalibration() {
                if (!this.searchVal) {
                    this.$message.error('请输入用户ID');
                    return false
                }
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                return true
            },
            getList(page = 1) {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                this.currentPage = page;

                this.getBatchUserStats({
                    userRandomIds: this.searchVal ? this.searchVal.split(',') : [],
                    coefficient: this.coefficient,
                    startTime: this.date && this.date[0],
                    endTime: this.date && this.date[1],
                    page
                }).then(res => {
                    this.batchUserStats = res.data;
                    this.loading = false;
                })
            },
            rowClick(row) {
                this.userId = row.userId;
                this.isUserStats = true;
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/gameDetail/batch/user/stats/export',
                    info: [
                        {name: 'userRandomIds', value: this.searchVal},
                        {name: 'coefficient', value: this.coefficient},
                        {name: 'startTime', value: this.date[0]},
                        {name: 'endTime', value: this.date[1]}
                    ]
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .common-header {
        max-width: 1200px;
        align-items: stretch;
    }

    .common-header-left {
        flex: 1;
        display: flex;
        line-height: 40px;
        :global(.el-textarea) {
            flex: 1;
        }
        :global(.el-textarea__inner) {
            height: 100%;
        }
    }

    .common-header-right {
        flex: none;
        width: 450px;
        margin-left: 10px;
    }
</style>